import { Spinner } from "react-bootstrap";
import "./style.scss";
export default function DBButton({
    type,
    caption,
    onClick,
    loading,
    disabled,
    className,
    outlined,
    style,
    title,
    ...rest
}) {
    return (
        <button
            type="button"
            className={[
                "db-button",
                type || "primary",
                className,
                outlined ? "outlined" : "",
            ]
                .filter(Boolean)
                .join(" ")}
            onClick={onClick}
            disabled={disabled || loading}
            style={style}
            title={title}
            {...rest}
        >
            {loading ? <Spinner animation="border" /> : caption}
        </button>
    );
}
